import Axios from 'axios';
import CryptoJS from 'crypto-js';
import Type from "../Redux/Type";
import { getListXa } from './Search';
import TNH_SETUP from './setup';
import setup from "./setup";
import { store } from '../Redux/Store';
const apiLink = setup.apiDebug
const apiLogin = 'https://ilis-sso.vnpt.vn/'
const apiLinkEnterprise = 'https://ilis-cadas-api.vnpt.vn/'

const secretKey = '123456qwertyasdfghzxcvbn!@#$%^';

const URL = {
    login: `${apiLink}Users/SignIn`,
    changePassWord: `${apiLink}Users/ChangePassword`,
    getPolygonByDistance: `${apiLink}BanDo/GetPolygonByCoord`,
    getPolygonByDistanceOLD: `${apiLink}BanDo/GetPolygonByDistance`,
    getPolygonByDistance2: `${apiLink}BanDo/GetPolygonByDistance_v1`,
    getPolygonByToThua: `${apiLink}BanDo/GetPolygonByThuaDat`,
    getTreeDVHC: (maTinh, capDo) =>
        `${apiLink}HanhChinh/GetDVHC?maTinh=${maTinh}&CapDo=${capDo}`,
    searchByToThua: `${apiLink}HienTrang/SearchThuaDatByToThua_CMU`,
    getGiaDat: `${apiLink}HienTrang/SearchThuaDatByToThuaV1`,
    searchByName: `${apiLink}HienTrang/SearchThuaDatByTenChu`,
    searchByLatLng: `${apiLink}BanDo/GetThongTinThuaDatPoint`,
    getQuyHoachInfo: `${apiLink}QuyHoach/GetThongTinQuyHoach`,
    getKhaoSatQuyHoach: `${apiLink}QuyHoach/GetThongKeKhaoSatQuyHoach`,
    getPolygonQuyHoach: key => `${apiLink}QuyHoach/GetPolygonQuyHoach?type=${key}`,
    getMenuQuyHoach: `${apiLink}QuyHoach/GetMenuQuyHoachNew?maTinh=${setup.tinhId}`,
    getDiaGioiHanhChinh: `${apiLink}QuyHoach/DANHMUCDVHC?maTinh=${setup.tinhId}&capDo=1`,
    getQuyHoachLayer: `${apiLink}ilis/wsilis_getDSPolygonQHTheoKhoangCach`,
    checkPermissionAddNote: `${apiLink}ghichu/checkPermissionAddNote`,
    uploadHinhAnh: (thuadat) =>
        `${apiLink}ghichu/uploadHinhAnh?soto=${thuadat.soto}&sothua=${thuadat.sothua}&madvhc=${thuadat.madvhc}`,
    loadListNoteByThuaDat: `${apiLink}ghichu/getListGhiChuByThuaDat`,
    loadListNoteByAccount: `${apiLink}ghichu/getListGhiChuByAccount`,
    createGhiChu: `${apiLink}ghichu/createGhiChu`,
    xoaGhiChu: `${apiLink}ghichu/xoaGhiChu`,
    root: apiLink,
    token: '@DataUserQHCMU',
	 getDanhMucGiaDat: loaidm => `${apiLink}HienTrang/LoadDanhMucGiaDat?loaidanhmuc=${loaidm}`,
    getDanhMucGiaDatDieuKien: (loaidm, maloai, maloai2) => `${apiLink}HienTrang/LoadDanhMucGiaDatDieuKien?loaidanhmuc=${loaidm}&maloai=${maloai}&maloai2=${maloai2}`,
    getGiaDatTheoTieuChi: (huyen,maxa,maloaidat,maduong ,madoan ) => `${apiLink}HienTrang/LoadThongTinGiaDat?huyen=${huyen}&maxa=${maxa}&maloaidat=${maloaidat}&maduong=${maduong}&madoan=${madoan}`,

    DownLoadAndroid: 'https://dl.dropboxusercontent.com/s/musqo6dwgyme0r7/app-release.apk?dl=0',
    DownLoadIOS: 'itms-services://vienthongtayninh.vn/?action=download-manifest&url=https://dl.dropboxusercontent.com/s/1sds6o83giu9jer/manifest.plist',

    //EnterPrise
    loginEnterPrise: `${apiLogin}connect/token`,
    searchByNameEnter: (name, iddvhc) => `${apiLinkEnterprise}api/DangKyQSDD/SearchViewDangKyDemo?PageSize=1000&CurentPage=1&iddvhc=${iddvhc}&tukhoa=${name}`,
    searchSoToDVHC: (soTo, dvhc) => `${apiLinkEnterprise}api/ToBanDo/SoTo/${soTo}/${dvhc}`,
    searchSoThuaDVHC: (soThua, idBanDo) => `${apiLinkEnterprise}api/DangKyQSDD/SearchViewDangKyDemo?PageSize=1000&CurentPage=1&tukhoa=${soThua}&searchExactly=true&idtobando=${idBanDo}`,
    getPolygonByToThuaEnter: `${apiLinkEnterprise}api/ThuaDat/GetByDSThuaDat`,
};

export default URL;



export const isObject = obj => obj && obj.constructor && obj.constructor === Object;

export function onPostRequest(url, onSuccess, payload) {

    let userinfo = store.getState().userInfo
    // console.log(userinfo)
    if (userinfo) {
        let exp = Date.parse(userinfo.Expired)
        let now = Date.now()
        if (now > exp) {
            localStorage.removeItem(URL.token);
            store.dispatch({ type: Type.SET_TOKEN, token: '' })
            store.dispatch({ type: Type.SET_USER_INFO, userInfo: '' });
        }
    }


    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = payload,
        token = store.getState().token,
        dataHeader = '';
    if (isObject(payload)) {
        let rawToken = token;
        if (token) {
            token = decodeResponse(token);
            token = JSON.parse(token);
        }
        payload = {
            Username: token.Username || '',
            Token: rawToken || '',
            ...payload,
        };
    }
    dataHeader = encodeResponse(payload);

    Axios.post(encodeURI(url), null, {
        headers: {
            'Content-Type': 'application/json',
            Data: dataHeader,
        }
    })
        .then((res) => {
            if (res.status === 401) {
                localStorage.removeItem(URL.token);
                store.dispatch({ type: Type.SET_TOKEN, token: '' })
                store.dispatch({ type: Type.SET_USER_INFO, userInfo: '' });
            }
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            if (error.response && error.response.status) {
                onSuccess({ statusCode: error.response.status, response: [] });
            }
            // let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            // handlerError(error, onSuccess, callBack);
        });
}

export function onRequestEnterPrise(url, onSuccess, payload, token) {
    let dataResponse = {
        statusCode: null,
        response: null,
    }

    if (isObject(payload)) {
        let rawToken = token;
        if (token) {
            token = decodeResponse(token);
            token = JSON.parse(token);
        }
        payload = {
            Username: token.Username || '',
            Token: rawToken || '',
            ...payload,
        };
    }
    Axios.post(encodeURI(url), payload
    )
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            const status = error.response.status;
            const res = null
            onSuccess({ status, res })
        });
}

export function onGetRequestEnterPriseBody(url, onSuccess, payload) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = payload,
        //token = store.getState().TokenEnter;
        token = localStorage.getItem(URL.token)
    if (isObject(payload)) {
        if (token) {
            token = decodeResponse(token);
            token = JSON.parse(token);
        }
    }

    Axios.get(url,
        {
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        }
    )
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);

        })
        .catch((error) => {
            // let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            // handlerError(error, onSuccess, callBack);
            if (error.response && error.response.status) {
                onSuccess({ statusCode: error.response.status, response: [] });
            }
        });

}
export function onGetRequestNoAuth(url, onSuccess) {
    let dataResponse = {
        statusCode: null,
        response: null,
    }
    Axios.get(url)
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);

        })
        .catch((error) => {
            // let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            // handlerError(error, onSuccess, callBack);
            if (error.response && error.response.status) {
                onSuccess({ statusCode: error.response.status, response: [] });
            }
        });

}
export function onPostRequestEnterPriseBody(url, onSuccess, payload) {
    let dataResponse = {
        statusCode: null,
        response: null,
    },
        rawDataHeader = payload,
        token = localStorage.getItem(URL.token)
    //token = store.getState().TokenEnter;
    const config = {
        method: 'post',
        url: url,
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        data: payload
    };
    Axios(config)
        .then((res) => {
            dataResponse.statusCode = res.status;
            dataResponse.response = res.data;
            onSuccess(dataResponse);
        })
        .catch((error) => {
            if (error.response && error.response.status) {
                onSuccess({ statusCode: error.response.status, response: [] });
            }
            // let callBack = () => onPostRequest(url, onSuccess, rawDataHeader);
            // handlerError(error, onSuccess, callBack);
            // if (error.response && error.response.status === 401) {
            //     onSignOut()
            // }
        });
}

export const b64DecodeUnicode = (str) => {
    return (
        decodeURIComponent(
            Array.prototype.map.call(atob(str), c =>
                '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            ).join(''))
    )
}


export const parseJwt = (token) => {
    return (
        JSON.parse(
            b64DecodeUnicode(
                token.split('.')[1].replace('-', '+').replace('_', '/')
            )
        ))
}


export function formatFLetter(inputString) {
    if (inputString) {
        inputString = inputString.split(' ');
        inputString = inputString.map(e => capitalizeFLetter(e));
        inputString = inputString.filter(e => !!e);
        return inputString.join(' ');
    }
    return ""
}

export function checkQuyenXemQuyHoach(tenquyhoach, Username) {
    if (tenquyhoach === null) {
        if (TNH_SETUP.accessAccount.setLogin === true && TNH_SETUP.accessAccount.listUsers.filter(e => e === Username).length > 0) {
            return true;
        }
        return false
    }
    else {
        if (TNH_SETUP.accessKey.filter(e => tenquyhoach.includes(e) === true).length > 0 && TNH_SETUP.accessAccount.setLogin === true) {
            if (TNH_SETUP.accessAccount.listUsers.filter(e => e === Username).length > 0) {
                return true;
            }
            return false
        }
        return true
    }
}

function capitalizeFLetter(inputStr) {
    if (inputStr) {
        inputStr = inputStr.toLowerCase();
        return inputStr.charAt(0).toUpperCase() +
            inputStr.slice(1)
    }
    return ""
}

export const removeMask = () => {
    //    document.get 
    if (TNH_SETUP.hackMap === true)
        setTimeout(() => {
            if (document.getElementsByClassName('gm-style')[0].children[1].children[0])
                document.getElementsByClassName('gm-style')[0].children[1].children[0].children[4].innerHTML =
                    document.getElementsByClassName('gm-style')[0].children[1].children[0].children[4].innerHTML.replaceAll('background-color: rgba(0, 0, 0, 0.5)', 'background-color: unset ; z-index: 0').replaceAll('For development purposes only', '')
        }, 500)
}

export const encodeResponse = (body) => {
    body = JSON.stringify(body);
    let key = CryptoJS.enc.Utf8.parse(secretKey);
    key = CryptoJS.MD5(key);
    key.words.push(key.words[0], key.words[1]);
    let options = { mode: CryptoJS.mode.ECB },
        textWordArray = CryptoJS.enc.Utf8.parse(body),
        encrypted = CryptoJS.TripleDES.encrypt(textWordArray, key, options);
    return encrypted.toString();
};

export const decodeResponse = (encryptedText) => {
    let key = CryptoJS.enc.Utf8.parse(secretKey);
    key = CryptoJS.MD5(key);
    key.words.push(key.words[0], key.words[1]);
    let options = { mode: CryptoJS.mode.ECB },
        decrypted = CryptoJS.TripleDES.decrypt(
            // @ts-ignore
            {
                ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
            },
            key,
            options,
        );
    return decrypted.toString(CryptoJS.enc.Utf8);
};

const handlerError = (error, onSuccess, callBack) => {
    let payload = {
        statusCode: 'Error',
        response: '',
    };
    if (error.response) {
        payload.response = error.response.data;
        payload.statusCode = error.response.status;
        if (error.response.status === 401) {
            onRefreshToken(callBack);
        }
        else
            onSuccess(payload);
    } else if (error.request) {
        payload.response = error.request;
        onSuccess(payload);
    } else {
        // Something happened in setting up the request that triggered an Error
        payload.response = error.message;
        onSuccess(payload);
    }
};

const onRefreshToken = (onSuccess) => {
    let token = store.getState().token;
    if (token) {
        token = decodeResponse(token);
        token = JSON.parse(token);
        let payload = {
            Username: token.Username,
            Password: token.Password,
        },
            strPayload = encodeResponse(payload);
        Axios.post(encodeURI(URL.login), null, {
            headers: {
                'Content-Type': 'application/json',
                Data: strPayload,
            },
        })
            .then((res) => {
                if (res.status === 200 && !!res.data) {
                    localStorage.setItem(URL.token, res.data)
                    store.dispatch({ type: Type.SET_TOKEN, token: res.data });
                    onSuccess();
                }
            })
            .catch((error) => {
                store.getState().signOut();
                if (error.response) {
                    console.log('response', error.response);
                } else if (error.request) {
                    console.log('req', error.request);
                } else {
                    console.log('Message', error.message);
                }
            });
    } else {
        store.getState().signOut();
    }
};

export const onLoadListXa = (huyenId) => {

    let onSuccess = (statusCode, response) => {
        if (statusCode === 200) {
            store.dispatch({ type: Type.SET_SEARCH, route: 'listWard', value: response });
            store.dispatch({ type: Type.SET_SEARCH, route: 'wardSelected', value: response[0] });
        }
        else
            return null
    };
    getListXa(huyenId, onSuccess);
};

export const formatNumber = number => {
    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

export const QD_GiaDat = {
    'QD': '(Số 35/2020/QĐ-UBND)',
    'HIEULUC': '01/09/2020',
}

